import { render, staticRenderFns } from "./cataloguer_setting.vue?vue&type=template&id=00136b89"
import script from "./cataloguer_setting.vue?vue&type=script&lang=js"
export * from "./cataloguer_setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports